import AuthCode from "react-auth-code-input";
import { verify2FA } from "../../api/login";
import { showToastError } from "../../services/toast";
import { useAuthStore } from "../../stores/auth";
import { ModalProps } from "../../interfaces/modal";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../contexts/userContext";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const Verify2FA: React.FC<ModalProps> = ({ closeModal }) => {
  const { email, code, setCode, remember, setRemember, reset } = useAuthStore();
  const navigate = useNavigate();

  //Context
  const { refreshUserData } = useUserContext();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Appel API
    verify2FA(email, code, remember)
      .then(async (res) => {
        // Après vérification 2FA réussie, rafraîchir les données utilisateur depuis l'API
        await refreshUserData();
        // Les données seront automatiquement mises à jour via le UserContext
        if (res?.data?.typeRole === "Customer") {
          navigate("/customer-area/dashboard");
        } else {
          navigate("/dashboard");
        }
        closeModal();
        reset();
      })
      .catch(() => {
        showToastError("Erreur lors de l'envoie de l'email");
      });
  };

  return (
    <ModalShell
      title="Vérification 2 FA"
      subtitle="Saisissez le code à 6 chiffres reçu par email."
      size="sm"
      onClose={() => closeModal()}
    >
      <form onSubmit={handleSubmit} className="font-Nunito">
        <div className="flex w-full items-center justify-center">
          <AuthCode
            allowedCharacters="numeric"
            length={6}
            onChange={(value) => setCode(value)}
            containerClassName="my-2 flex gap-2"
            inputClassName="size-11 rounded-xl border border-slate-200 bg-slate-50 text-center text-lg font-bold text-slate-800 transition-colors focus:border-indigo-300 focus:bg-white focus:ring-2 focus:ring-indigo-100 focus:outline-none"
          />
        </div>

        <div className="mt-4 flex flex-col gap-3 border-t border-slate-100 pt-4 sm:flex-row sm:items-center sm:justify-between">
          <label
            htmlFor="remember"
            className="flex cursor-pointer items-start gap-2.5 text-sm text-slate-600"
          >
            <input
              type="checkbox"
              name="remember"
              id="remember"
              className="mt-0.5 size-4 cursor-pointer accent-dca-blue"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
            />
            <span>
              Se souvenir de moi
              <span className="block text-xs text-slate-400">
                Pour les 14 prochains jours
              </span>
            </span>
          </label>

          <ModalButton variant="primary" type="submit">
            Envoyer
          </ModalButton>
        </div>
      </form>
    </ModalShell>
  );
};

export default Verify2FA;